import { ImpactStyle } from "@capacitor/haptics";
import { DotsVerticalIcon } from "@heroicons/react/solid";
import * as React from "react";
import { hapticsImpact } from "~/config/capacitor/haptics/hook";
import { createComponentHook } from "~/types";
import type { ButtonProps } from "../Button";
import { Button, ButtonSize } from "../Button";
import { DropdownMenu } from "../DropdownMenu";
import type { DropdownMenuContentProps } from "../DropdownMenu/components/DropdownMenuContent";
import { DropdownMenuContent } from "../DropdownMenu/components/DropdownMenuContent";
import { Icon, IconSize } from "../Icon";

type ExtraButtonProps = ButtonProps & {
  children: DropdownMenuContentProps["children"];
  side?: DropdownMenuContentProps["side"];
  onImportComponents?: () => Promise<void>;
};

const ExtraButtonSizeToIconSize = new Map([
  [ButtonSize.XSMALL, IconSize.XSMALL],
  [ButtonSize.SMALL, IconSize.SMALL],
  [ButtonSize.STANDARD, IconSize.MEDIUM],
  [ButtonSize.LARGE, IconSize.MEDIUM],
  [ButtonSize.XLARGE, IconSize.XLARGE],
]);

const useExtraButton = createComponentHook(() => {
  const handleOpenChange = (open: boolean) => {
    if (open) {
      void hapticsImpact(ImpactStyle.Light);
    }
  };

  return {
    actions: {
      handleOpenChange,
    },
  };
});

function ExtraButton(props: ExtraButtonProps) {
  const { actions } = useExtraButton();
  const {
    children,
    onImportComponents: onImportComponents,
    side,
    ...buttonProps
  } = props;
  return (
    <DropdownMenu
      onOpenChange={async (open) => {
        await onImportComponents?.();
        actions.handleOpenChange(open);
      }}
      trigger={
        <Button
          css={{ paddingLeft: "$xsmall", paddingRight: "$xsmall" }}
          {...buttonProps}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon
            size={
              props.size ? ExtraButtonSizeToIconSize.get(props.size) : "medium"
            }
            label={buttonProps.iconLabel ?? "vertical dots icon"}
          >
            <DotsVerticalIcon />
          </Icon>
        </Button>
      }
    >
      <DropdownMenuContent
        onClick={(e) => {
          e.stopPropagation();
        }}
        align="end"
        side={side}
      >
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { ExtraButton, useExtraButton };
